import { z } from 'zod';
export const EDUCATION_TOPICS = ['diagnosis', 'medicines', 'diet', 'danger_signs', 'follow_up', 'hygiene', 'other'];
export const opdScreeningSchema = z
    .object({
    pain: z.object({ score: z.number().int().min(0).max(10), site: z.string().trim().max(120).optional() }).optional(),
    fallRisk: z
        .object({
        historyOfFalls: z.boolean(),
        walkingAid: z.boolean(),
        dizziness: z.boolean(),
        unsteadyGait: z.boolean(),
    })
        .optional(),
    nutrition: z.object({ weightLoss: z.boolean(), reducedIntake: z.boolean() }).optional(),
    functional: z.object({ dependence: z.enum(['independent', 'needs_help', 'dependent']) }).optional(),
    socialNeeds: z.string().trim().max(500).optional(),
    pregnancy: z
        .object({
        status: z.enum(['not_pregnant', 'pregnant', 'possible', 'unknown']),
        lmp: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    })
        .optional(),
    educationGiven: z.object({ topics: z.array(z.enum(EDUCATION_TOPICS)).max(10) }).optional(),
})
    .strict();
export const recordScreeningSchema = z.object({
    appointmentId: z.string().uuid(),
    data: opdScreeningSchema,
});
export function fallRiskScore(data) {
    if (!data.fallRisk)
        return null;
    return Object.values(data.fallRisk).filter(Boolean).length;
}
export function screeningIsEmpty(data) {
    return Object.values(data).every((value) => value === undefined);
}
//# sourceMappingURL=opd-screening.js.map